import React from 'react';

import SelectBox from 'devextreme-react/select-box';

export const FormSelectBox = ({
  value,
  readOnly,
  dataSource,
  displayExpr,
  valueExpr,
  label,
  showClearButton,
  onValueChange,
  children
}) => {
  return (
    <SelectBox
    label={label}
    width='100%'  
    value={value}
    readOnly={readOnly}
    dataSource={dataSource}
    displayExpr={displayExpr}
    valueExpr={valueExpr}
    stylingMode='filled'
    inputAttr={{ class: 'form-editor-input' }}
    onValueChange={onValueChange}
    showClearButton={showClearButton}
    searchEnabled={true}
   >
        {children}
    </SelectBox>
  );
};
